export const GOOGLE_AD_CLIENT_ID = process.env.VITE_GOOGLE_AD_CLIENT_ID;
export const SQUARE_AD_SLOT_ID = process.env.VITE_SQUARE_AD_SLOT_ID;
